import { useCrmAutoFill } from '../../Hooks';

/**
 * CrmAutoFill
 * @returns {null}
 *
 * This component is used to trigger the CRM auto-fill functionality.
 *
 * If a url param called cgid exists, we will decrypt data from it via an external decryption service and populate the JSON data within, using a mapping of question id/name to component id, which comes from the store.
 */
const CrmAutoFill = () => {
  useCrmAutoFill();
  return null;
};

export default CrmAutoFill;
